import { call, put, takeEvery } from "redux-saga/effects";

import * as adminApis from "../../../network/apis/applicants";
import * as companyApis from "../../../network/apis/companyPortalUsers";
import { normalizeApplicantProfile } from "../../../containers/Company-portal/Applicants/ViewApplicantProfile/profileHelpers";
import { showErrorMsg } from "../../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";

function* getCompanyApplicantProfileSaga({ payload }) {
  const { id, portal = "company", onError } = payload || {};
  const isAdmin = portal === "admin";

  try {
    const response = yield call(
      isAdmin ? adminApis.getApplicant : companyApis.getApplicantProfile,
      isAdmin ? +id : id,
    );
    yield put(
      actions.getCompanyApplicantProfileResponse({
        profile: normalizeApplicantProfile(response?.data?.data),
        notFound: false,
      }),
    );
  } catch (error) {
    const status = error?.response?.status;
    if (status === 404) {
      yield put(
        actions.getCompanyApplicantProfileResponse({
          profile: null,
          notFound: true,
        }),
      );
      return;
    }

    const message = error?.response?.data?.message;
    if (message) yield call(showErrorMsg, message);
    yield put(
      actions.getCompanyApplicantProfileResponse({
        profile: null,
        notFound: false,
      }),
    );
    if (typeof onError === "function") onError(error);
  }
}

export default function* companyApplicantProfileSagas() {
  yield takeEvery(
    types.GET_COMPANY_APPLICANT_PROFILE_REQUEST,
    getCompanyApplicantProfileSaga,
  );
}
